import {Button, type ButtonSize, IconButton} from '@wandb/components';
import React from 'react';

interface ViewInGrafanaButtonProps {
  grafanaUrl: string;
  /** Visual variant. 'default' has a background; 'ghost' is transparent. */
  variant?: 'default' | 'ghost';
  /** Button size. @default "sm" */
  size?: ButtonSize;
  /** Render as icon-only button without text. */
  iconOnly?: boolean;
}

export function ViewInGrafanaButton({
  grafanaUrl,
  variant = 'default',
  size = 'sm',
  iconOnly = false,
}: ViewInGrafanaButtonProps) {
  if (iconOnly) {
    return (
      <IconButton
        icon="grafana-mono"
        variant={variant === 'ghost' ? 'ghost' : 'secondary'}
        size={size}
        tooltip={{children: 'View in Grafana'}}
        aria-label="View in Grafana"
        // oxlint-disable-next-line wandb/no-unprefixed-urls
        href={grafanaUrl}
        target="_blank"
        rel="noopener noreferrer"
      />
    );
  }

  return (
    <Button
      variant={variant === 'ghost' ? 'ghost' : 'secondary'}
      size={size}
      startIcon="grafana-mono"
      // oxlint-disable-next-line wandb/no-unprefixed-urls
      href={grafanaUrl}
      target="_blank"
      rel="noopener noreferrer">
      View in Grafana
    </Button>
  );
}
